import { useMediaQuery } from "@mui/material";
import React from "react";
import { theme } from "@/theme";
import { Carousel } from "@/components/carousel";
import { ProductCardCombined } from "./ProductCardCombined";
import { ShoppableProductCardCombined } from "./ShoppableProductCardCombined";
import { SkeletonProductCard } from "./SkeletonProductCard";
import { cn } from "@/helpers/utils";
import { ProductCardListProps } from "./ProductCardList";

export const ProductCardListCollection = (props: ProductCardListProps) => {
  const isSmallScreen = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.md)
  );
  const isCarousel = props?.layout !== "grid" && props?.layout !== "flex";
  const isFlexLayout = props?.layout === "flex";
  const productCardProps = {
    className: cn(
      "h-full",
      isSmallScreen &&
        isCarousel &&
        "shadow-lg border border-solid border-transparent hover:border-primary-200"
    ),
    truncateText: isCarousel,
  };

  const productCards = props.shoppable
    ? props.products.map((product) => {
        const isSkeleton = "imageHeight" in product;
        // Removed the SkeletonProductCard componet. It was causing CLS issue
        return isSkeleton ? null : (
          <ShoppableProductCardCombined
            key={product.id}
            {...productCardProps}
            product={product}
            showRatings={!product?.product?.tags?.includes("hide-reviews")}
          />
        );
      })
    : props.products.map((product) => {
        const isSkeleton = "imageHeight" in product;
        return isSkeleton ? null : (
          <ProductCardCombined
            {...productCardProps}
            compact={true}
            productCardValue={product}
            showRatings={!product?.product?.tags?.includes("hide-reviews")}
          />
        );
      });

  if (isCarousel && isSmallScreen) {
    const slides = productCards.map((elem, i) => (
      <div key={i} className="mb-6 mt-1 w-full max-w-full px-12">
        {elem}
      </div>
    ));

    return (
      <Carousel
        items={slides}
        dots="none"
        slidePosition="stretch"
        slideGap={false}
        arrows={{ gutter: "none", variant: "blue-icon" }}
      />
    );
  }

  const items = productCards.map((elem, i) => (
    <React.Fragment key={i}>
      <li className="max-w-full">{elem}</li>
      <li className="product-card__divider lg:hidden">
        <hr data-id="product-card-divider" className="divider-x my-0"></hr>
      </li>
    </React.Fragment>
  ));

  if (isCarousel) {
    // Carousel layout
    return (
      <ul className="negative-margin-overide -my-4 grid grid-cols-1 gap-4 gap-y-8 md:grid-cols-2 lg:grid-cols-4">
        {items}
      </ul>
    );
  } else if (isFlexLayout) {
    // Flex layout
    return (
      <div className="flex flex-wrap justify-center">
        {items.map((elem, i) => (
          <div key={i} className="flex-1">
            {elem}
          </div>
        ))}
      </div>
    );
  } else {
    // Default to grid layout if not carousel or flex
    return (
      <ul
        className={`negative-margin-overide -my-4 grid grid-cols-1 gap-y-6 sm:gap-2 md:gap-4 md:gap-y-8 lg:grid-cols-4`}
      >
        {items}
      </ul>
    );
  }
};
